import { useTheme } from "@emotion/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganisations } from "reduxStore/actions/organisationActions";
import { EditOutlined } from "@mui/icons-material";

export const useOrgGrid = ({ handleEditOpen }) => {
  const { palette } = useTheme();
  const backgroundAlt = palette.background.alt;
  const primaryLight = palette.primary.light;
  const primaryDark = palette.primary.dark;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const dispatch = useDispatch();

  const organisations = useSelector((state) => state.organisations.data) || [];
  const totalOrgs = useSelector((state) => state.organisations.total) || 0;

  useEffect(() => {
    const filters = {
      page,
      pageSize,
      sort,
      search,
    };
    dispatch(fetchOrganisations(filters));
  }, [page, pageSize, sort, search, dispatch]);

  const columns = [
    { field: "name", headerName: "Organisation Name", flex: 1 },
    { field: "description", headerName: "Description", flex: 2 },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      renderCell: (params) => moment(params.value).format("ll"),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      renderCell: (params) => moment(params.value).format("ll"),
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.5,
      renderCell: (params) => (
        <button
          onClick={() => handleEditOpen(params.row)} // Open the edit dialog with unit details
          style={{ backgroundColor: "transparent", border: "none" }}
        >
          <EditOutlined sx={{ color: primaryDark }} />
        </button>
      ),
    },
  ];

  return {
    organisations,
    totalOrgs,
    columns,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    searchInput,
    setSearchInput,
    sort,
    setSort,
    backgroundAlt,
    primaryLight,
  };
};
